import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_descriptions = _resolveComponent("el-descriptions");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_descriptions, {
    title: _ctx.processInfo.demandName,
    column: 1,
    border: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
      label: "需求类型"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.demandTypeComputed), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "需 求 人"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.processInfo.userName), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "申请时间"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.processInfo.askTime), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "联系电话"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.processInfo.mobile), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "需求部门"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.processInfo.demandDep), 1)]),
      _: 1
    }), _ctx.processInfo.demandType === 0 && _ctx.processInfo.assetsName ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
      key: 0,
      label: "需求运营位"
    }, {
      default: _withCtx(() => [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processInfo.assetsName.split(','), (s, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, _toDisplayString(index + 1) + "、" + _toDisplayString(s), 1);
      }), 128))])]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.processInfo.demandType === 1 && _ctx.processInfo.assetsName ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
      key: 1,
      label: "IOP短信发送渠道"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.processInfo.assetsName), 1)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.processInfo.demandType === 1 ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
      key: 2,
      label: "短信内容"
    }, {
      default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx.processInfo.smsContent), 1)]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_descriptions_item, {
      label: "需求备注"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.processInfo.demandRemark), 1)]),
      _: 1
    }), _ctx.processInfo.handleTime ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
      key: 3,
      label: "处理时间"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.processInfo.handleTime), 1)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.processInfo.status === '1' ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
      key: 4,
      label: "审批结果"
    }, {
      default: _withCtx(() => [_ctx.processInfo.approveResult === '1' ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 0,
        type: "success",
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" 同意 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true), _ctx.processInfo.approveResult === '0' ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 1,
        type: "danger",
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode(" 不同意 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true), _ctx.processInfo.approveResult === '2' ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 2,
        type: "info",
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" 需求关闭 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.processInfo.status === '1' ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
      key: 5,
      label: "审批意见"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.processInfo.remark), 1)]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["title"]), _ctx.processInfo.status === '0' ? (_openBlock(), _createBlock(_component_el_form, {
    key: 0,
    "label-width": "80px",
    style: {
      "margin-top": "5px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: "审批结果"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        modelValue: _ctx.approveResult,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.approveResult = $event),
        label: "1"
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("同意", -1)]))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
        modelValue: _ctx.approveResult,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.approveResult = $event),
        label: "0"
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("驳回", -1)]))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "审批备注"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        type: "textarea",
        modelValue: _ctx.remark,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.remark = $event),
        maxlength: "1000",
        "show-word-limit": ""
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, null, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.onSubmit
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("提交", -1)]))]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        onClick: _ctx.onCancel
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("取消", -1)]))]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true)]);
}